import React from 'react'
import { Alert as AlertBootstrap } from 'react-bootstrap'
import { isEmpty } from 'lodash'

const Alert = ({
  text,
  variant,
  dismissible = true,
  onClose
}) => {
  if (isEmpty(text)) return null

  return (
    <AlertBootstrap
      dismissible={dismissible}
      onClose={onClose}
      variant={variant}
    >
      {text}
    </AlertBootstrap>
  )
}

export default Alert
